// extracted by mini-css-extract-plugin
export default {"modal":"Map_modal__50d9K","modal_body":"Map_modal_body__RdbSm","modal_name":"Map_modal_name__m6W77","modal_button":"Map_modal_button__Qq5np"};